import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { CarDetailsQueryKeys } from "modules/CarDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { CarNote } from "models";

const handleAddCarNoteOnAppointmentCar = (noteId: number, payload: CarNote) => {
  const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
  if (!appointment?.car) return;

  const appointmentCarNoteIdx = appointment.car.notes?.findIndex(note => note.id === noteId) ?? -1;
  if (appointmentCarNoteIdx > -1) return;

  typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
    ...appointment,
    car: { ...appointment.car, notes: [...(appointment.car.notes ?? []), { ...payload, id: noteId }] }
  });
};

const handleAddCarNoteOnCar = (noteId: number, payload: CarNote) => {
  const car = typedQueryClient.getQueryData(CarDetailsQueryKeys.details);
  if (!car) return;

  const carNoteIdx = car.notes?.findIndex(note => note.id === noteId) ?? -1;
  if (carNoteIdx > -1) return;

  typedQueryClient.setQueryData(CarDetailsQueryKeys.details, { ...car, notes: [...(car.notes ?? []), { ...payload, id: noteId }] });
};

export const useCreateCarNoteMutation = () =>
  useTypedMutation<CarNote, number>({
    mutationFn: async payload => (await ApiInstance.post("/notes/create", payload, ENV.carBaseURL)).data.car_note_id,
    onSuccess: (payload, noteId) => {
      handleAddCarNoteOnCar(noteId, payload);
      handleAddCarNoteOnAppointmentCar(noteId, payload);
    }
  });
